import { cellStyle } from "../../../../components/Table/Table.styles";
import { roundToTwo } from "../../../../services/utils/roundToTwo";

export const toNumber = (item: any) => {
  return Number(item.replace(/[^0-9.-]+/g, ""));
};

// define your filters
export const defaultSliderFilters = [
  { id: 4, title: "Score", min: 0, max: 3 },
  { id: 5, title: "Check-ins", min: 0, max: 150 },
  { id: 6, title: "OT", min: 0, max: 200 },
  { id: 7, title: "PTO", min: 0, max: 200 },
  { id: 8, title: "Avg. Hours", min: 0, max: 120 },
  { id: 8, title: "Win Rate", min: 0, max: 100 },
  { id: 8, title: "Avg. Ticket", min: 0, max: 1000 },
  { id: 8, title: "Avg. Comp", min: 0, max: 50000 },
  { id: 8, title: "Advantage %", min: 0, max: 100 },
  { id: 8, title: "Referrals", min: 0, max: 999 },
];

// define your columns
export const getColumns = (token: string) => {
  return [
    {
      title: "Member",
      field: "fullName",
      cellStyle: cellStyle,
      render: (member: any) => {
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <img
              src={`${process.env.REACT_APP_API_URL}/members/${member.id}/photo?authorization=${token}`}
              style={{
                marginRight: "9.22px",
                height: "32px",
                width: "40px",
                borderRadius: "7px",
                objectFit: "cover",
              }}
            />
            <span
              style={{
                fontWeight: "600" as any,
                lineHeight: "18px",
                color: "#373F41",
              }}
            >
              {member.fullName}
            </span>
          </div>
        );
      },
    },
    {
      title: "Score",
      field: "score",
      searchable: false,
      type: "numeric",
      align: "left",
      cellStyle: cellStyle,
      customFilterAndSearch: (value: Array<number>, rowData: any) =>
        rowData.score >= value[0] && rowData.score <= value[1],
      render: (data: any) => {
        return roundToTwo(parseFloat(data.score));
      },
    },
    {
      title: "Check-ins",
      field: "totalCheckins",
      searchable: false,
      type: "numeric",
      align: "left",
      cellStyle: cellStyle,
      customFilterAndSearch: (value: Array<number>, rowData: any) =>
        rowData.totalCheckins >= value[0] && rowData.totalCheckins <= value[1],
    },
    {
      title: "OT",
      field: "overTime",
      searchable: false,
      type: "numeric",
      align: "left",
      cellStyle: cellStyle,
      customFilterAndSearch: (value: Array<number>, rowData: any) =>
        rowData.overTime >= value[0] && rowData.overTime <= value[1],
      render: (data: any) => {
        return roundToTwo(parseFloat(data.ot));
      },
    },
    {
      title: "PTO",
      field: "pto",
      searchable: false,
      type: "numeric",
      align: "left",
      cellStyle: cellStyle,
      customFilterAndSearch: (value: Array<number>, rowData: any) =>
        rowData.pto >= value[0] && rowData.pto <= value[1],
      render: (data: any) => {
        return roundToTwo(parseFloat(data.pto));
      },
    },
    {
      title: "Avg. Hours",
      field: "avgHours",
      searchable: false,
      type: "numeric",
      align: "left",
      cellStyle: cellStyle,
      customFilterAndSearch: (value: Array<number>, rowData: any) =>
        rowData.avgHours >= value[0] && rowData.avgHours <= value[1],
      render: (data: any) => {
        return roundToTwo(parseFloat(data.avgHours));
      },
    },
    {
      title: "Win Rate",
      field: "winRate",
      searchable: false,
      type: "numeric",
      align: "left",
      cellStyle: cellStyle,
      customFilterAndSearch: (value: Array<number>, rowData: any) =>
        rowData.winRate >= value[0] && rowData.winRate <= value[1],
      render: (data: any) => {
        return roundToTwo(parseFloat(data.winRate));
      },
    },
    {
      title: "Avg. Ticket",
      field: "avgTicket",
      searchable: false,
      type: "numeric",
      align: "left",
      cellStyle: cellStyle,
      customFilterAndSearch: (value: Array<number>, rowData: any) =>
        toNumber(rowData.avgTicket) >= value[0] &&
        toNumber(rowData.avgTicket) <= value[1],
      render: (data: any) => {
        return roundToTwo(parseFloat(data.avgTicket));
      },
    },
    {
      title: "Avg. Comp",
      field: "avgComp",
      searchable: false,
      type: "numeric",
      align: "left",
      cellStyle: cellStyle,
      customFilterAndSearch: (value: Array<number>, rowData: any) =>
        rowData.avgComp >= value[0] && rowData.avgComp <= value[1],
      render: (data: any) => {
        return roundToTwo(parseFloat(data.avgComp));
      },
    },
    {
      title: "Advantage",
      field: "mam",
      searchable: false,
      type: "numeric",
      align: "left",
      cellStyle: cellStyle,
      customFilterAndSearch: (value: Array<number>, rowData: any) =>
        rowData.mam >= value[0] && rowData.mam <= value[1],
      render: (data: any) => {
        return roundToTwo(parseFloat(data.mam));
      },
    },
    {
      title: "Referrals",
      field: "referrals",
      searchable: false,
      type: "numeric",
      align: "left",
      cellStyle: cellStyle,
      customFilterAndSearch: (value: Array<number>, rowData: any) =>
        rowData.referrals >= value[0] && rowData.referrals <= value[1],
      render: (data: any) => {
        return roundToTwo(parseFloat(data.referrals));
      },
    },
  ];
};
